import { BaseDataBind } from "./base";

export abstract class BaseSelectBoxDataBind extends BaseDataBind
{   
    /**
     * Iterates over select element options.
     * @param element The element to iterate.
     * @param callback Callback function called for each option.
     */
    protected iterateOptions(element: HTMLSelectElement, callback: (option: HTMLOptionElement, index: number) => void)
    {
        for(let i = 0; i < element.options.length; i++)
        {
            callback(element.options[i] as HTMLOptionElement, i);
        }
    }

    /**
     * Converts various input types to a string array.
     * @param value The value to parse.
     */
    protected parseOptions(value: any): string[]
    {
        let temp: string[] = [];

        if (typeof value === 'number')
        {
            temp = [value.toString()];
        }
        if (typeof value === 'string')
        {
            temp = value.split(',');
        }
        else if (Array.isArray(value))
        {
            temp = value;
        }

        let result: string[] = [];
        for (let s of temp)
        {
            if (s !== undefined && s !== null && s.length > 0)
            {
                result.push(s);
            }
        }

        return result;
    }
}